import React from 'react';
import Icon from '../AppIcon';

const StatusIndicator = ({ 
  status = 'pending',
  label,
  size = 'default',
  showIcon = true,
  variant = 'chip'
}) => {
  const statusConfig = {
    draft: {
      color: 'bg-muted text-muted-foreground',
      icon: 'FileEdit',
      label: 'Draft'
    },
    pending: {
      color: 'bg-warning/10 text-warning',
      icon: 'Clock',
      label: 'Pending'
    },
    'in-progress': {
      color: 'bg-primary/10 text-primary',
      icon: 'Loader',
      label: 'In Progress'
    },
    'under-review': {
      color: 'bg-warning/10 text-warning',
      icon: 'Eye',
      label: 'Under Review'
    },
    approved: {
      color: 'bg-success/10 text-success',
      icon: 'CheckCircle',
      label: 'Approved'
    },
    rejected: {
      color: 'bg-error/10 text-error',
      icon: 'XCircle',
      label: 'Rejected'
    },
    completed: {
      color: 'bg-success/10 text-success',
      icon: 'CheckCircle2',
      label: 'Completed'
    },
    cancelled: {
      color: 'bg-error/10 text-error',
      icon: 'Ban',
      label: 'Cancelled'
    },
    active: {
      color: 'bg-success/10 text-success',
      icon: 'Activity',
      label: 'Active'
    },
    inactive: {
      color: 'bg-muted text-muted-foreground',
      icon: 'Pause',
      label: 'Inactive'
    }
  };

  const config = statusConfig?.[status] || statusConfig?.draft;
  const displayLabel = label || config?.label;

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    default: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base'
  };

  const iconSizes = {
    sm: 12,
    default: 14,
    lg: 16
  };

  if (variant === 'dot') {
    return (
      <div className="flex items-center gap-2">
        <div className={`w-2 h-2 rounded-full ${config?.color?.split(' ')?.[0]}`} />
        <span className="text-sm text-foreground">{displayLabel}</span>
      </div>
    );
  }

  if (variant === 'badge') {
    return (
      <div className={`inline-flex items-center gap-1.5 ${sizeClasses?.[size]} rounded-full ${config?.color} font-medium`}>
        {showIcon && <Icon name={config?.icon} size={iconSizes?.[size]} />}
        <span>{displayLabel}</span>
      </div>
    );
  }

  return (
    <div className={`inline-flex items-center gap-1.5 ${sizeClasses?.[size]} rounded-md ${config?.color} font-medium transition-smooth`}>
      {showIcon && <Icon name={config?.icon} size={iconSizes?.[size]} />}
      <span>{displayLabel}</span>
    </div>
  );
};

export default StatusIndicator;